import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined"
import MoreHorizIcon from "@mui/icons-material/MoreHoriz"
import PlayArrowIcon from "@mui/icons-material/PlayArrow"
import { ButtonBase, Menu, MenuItem } from "@mui/material"
import { ColumnDef } from "@tanstack/react-table"
import moment from "moment"
import { useState } from "react"
import { AuditStatus, GetAllAuditsQuery } from "src/graphql/quark/quark.type"
import { ChipStyled, Conditional } from "src/shared/components"
import { capitalizeFirstLetter } from "src/shared/utils/data-helpers"
import { getDisplayPrice } from "src/shared/utils/helpers-functions"
import { getAuditTypeColor, getAuditTypeLabel } from "../../components/AuditDetailModal"

type OnActionT = (type: "continue" | "detail", val: any) => void
const getAuditListColumns = ({
  onAction
}: {
  onAction: OnActionT
}): ColumnDef<GetAllAuditsQuery["getAllAudits"]["data"][number]>[] => {
  return [
    {
      accessorKey: "secondaryId",
      header: "ID"
    },
    {
      accessorKey: "status",
      header: "Status",
      cell: ({ row }) => (
        <ChipStyled
          label={capitalizeFirstLetter(row.original.status?.replace("_", " ") ?? "")}
          size="small"
          variant="filled"
          color={row.original.status === "COMPLETED" ? "success" : "default"}
        />
      )
    },
    {
      accessorKey: "type",
      header: "Type",
      cell: ({ row }) => (
        <ChipStyled
          label={getAuditTypeLabel(row.original.type)}
          size="small"
          variant="filled"
          color={getAuditTypeColor(row.original.type) as any}
        />
      )
    },
    {
      accessorKey: "itemCount",
      header: "No of Products"
    },
    {
      accessorKey: "lotCount",
      header: "No of Lots"
    },
    {
      accessorKey: "matchedProducts",
      header: "Matched Lots"
    },
    {
      accessorKey: "shortProducts",
      header: "Short Lots"
    },
    {
      accessorKey: "shortStockValue",
      header: "Short Stock Value",
      accessorFn: (row) => getDisplayPrice(row.shortStockValue ?? 0)
    },
    {
      accessorKey: "excessProducts",
      header: "Excess Lots"
    },
    {
      accessorKey: "excessStockValue",
      header: "Excess Stock Value",
      accessorFn: (row) => getDisplayPrice(row.excessStockValue ?? 0)
    },
    {
      accessorKey: "createdAt",
      header: "Created At",
      accessorFn: (row) => moment(row.createdAt).format("lll")
    },
    {
      id: "actions",
      header: "Actions",
      meta: {
        sticky: "right",
        width: "100px",
        minWidth: "100px",
        textAlign: "center",
        headerAlign: "center"
      },
      cell: ({ row }) => {
        return <ActionMenu data={row.original} onAction={onAction} />
      }
    }
  ]
}

export default getAuditListColumns

const ActionMenu = ({ data, onAction }: { data: any; onAction: OnActionT }) => {
  const [anchorEl, setanchorEl] = useState<any>()
  // const { hasPermission } = usePermission()

  // <AssignmentIcon fontSize="inherit" sx={{ mr: 1 }} />
  console.log("data", data)
  return (
    <>
      {/* <Tooltip title={isDisabledAction ? "You don't have permission" : ""}> */}
      <ButtonBase
        aria-controls="action-menu"
        aria-haspopup="true"
        id="action-button"
        // disabled={isDisabledAction}
        onClick={(e) => {
          setanchorEl(e.currentTarget)
        }}
      >
        <MoreHorizIcon />
      </ButtonBase>
      {/* </Tooltip> */}
      <Menu
        id="action-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setanchorEl(null)}
        MenuListProps={{
          "aria-labelledby": "basic-button"
        }}
      >
        {/* <Conditional condition={hasPermission("procurement:purchase-order:details")}> */}
        <MenuItem
          onClick={() => {
            setanchorEl(null)
            onAction("detail", data?.id)
          }}
          dense
        >
          <InfoOutlinedIcon fontSize="inherit" sx={{ mr: 1 }} /> Details
        </MenuItem>
        {/* </Conditional> */}

        <Conditional condition={data?.status === AuditStatus.InProgress}>
          <MenuItem
            dense
            onClick={() => {
              setanchorEl(null)
              onAction("continue", data?.id)
            }}
          >
            <PlayArrowIcon fontSize="inherit" sx={{ mr: 1 }} />
            Continue
          </MenuItem>
        </Conditional>
      </Menu>
    </>
  )
}
